import { getStore } from 'owa-mail-reading-pane-store/lib/store/Store';

export default function isConversationReadingPaneViewStateLoaded(conversationId: string): boolean {
    return getStore().loadedConversationReadingPaneViewStates.has(conversationId);
}
